export const TERMS = {
  '置信度': 'AI对当前判断的把握程度，数值越高表示越确定，但并非绝对结论。',
  '不确定性': 'AI在不同视角或多次计算下结果的一致性，越高说明越犹豫，建议结合临床复核。',
  '热力图': '用颜色标注高风险（红）、可疑（橙）、正常（蓝）区域，帮助理解AI决策。',
  '关注区域': 'AI重点关注的影像区域，提示需要医生重点复核的位置。',
  '鉴别诊断': '对多种可能疾病的综合对比与概率评估，辅助医生判断。',
  '建议': '基于影像特征与模型判断的检查与随访建议。',
  '诊断概率': '各候选诊断的概率估计，用于对比不同可能性。',
  '特征': 'AI识别出的形状、密度、边界、纹理等关键影像特征。',
  '医学影像分析': '针对医学图像进行AI识别与辅助诊断的整体流程。',
  '历史诊断报告': '过去生成的分析报告列表，可查看或下载。',
  '检测结果': 'AI认为可能存在病变的项目及其位置与置信度。',
  '病例详情': '某次分析的详细信息，包括影像与结果概览。',
  '基本信息': '报告编号、时间、模型版本、耗时等基础资料。',
  '模型版本': '当前使用的AI模型版本，便于追踪与对比。',
  '分析耗时': '本次分析所用时间，仅作性能参考。',
  '原始医学影像': '未处理的原始影像，用于与热力图等对照。',
  '分析结果': '本次分析的总体结论与概览。',
  '快速分析': '强调处理速度，帮助用户尽快得到初步结果。',
  '精准识别': '强调准确度与定位效果，但应结合临床综合判断。',
  '专业报告': '结构化呈现检测结果、特征与建议，便于医生与用户理解。',
  '上传医学影像': '选择或拖拽上传医学影像文件以开始分析。',
  '支持格式': '平台支持的文件类型，常见如DICOM、NIfTI、PNG、JPG。',
  '最大文件大小': '单个文件允许上传的大小上限，超出会被拒绝。',
  '调用pythonAI分析': '调用Python AI服务进行标准分析流程。',
  '调用DeepSeek分析': '调用DeepSeek通道进行分析，并生成报告与可视化。'
}
